module.exports = __webpack_public_path__ + "static/img/2_2_3_3.323297f2.jpg";